export const modules = {
  toolbar: {
    container: [
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { size: ["small", false, "large", "huge"] },
        { color: [] },
        { background: [] },
      ],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
        { align: [] },
      ],
      ["link", "code-block"],

      ["clean"],
    ],
  },
  clipboard: { matchVisual: false },
};
export const modulesForTechnicalData = {
  toolbar: {
    container: [
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
    ],
  },
  clipboard: { matchVisual: false },
};

export const hideToolbar = { toolbar: false };

export const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "size",
  "color",
  "background",
  "link",
  "list",
  "bullet",
  "indent",
  "align",
  "code-block",
];
export const formatsForTechnicalData = [
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
];
